<template>
  <div>
        <div class="formBlock">
            <div class="blockTitle noMargin">{{messages["qsim.title"]}}</div>
            <p class="blockSubtitle">{{messages["qsim.subtitle"]}}</p>
            <div class="packs-table">
              <!-- ko foreach: Products -->
              <div class="item" v-for="product in atgProducts" :key="product.productId">
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div :id="product.productId" class="checkbox productCheckbox" @click="selectSimProduct($event)">
                                    <span class="input icon">
                                        <input type="checkbox">
                                    </span>
                                </div>
                            </td>
                            <td class="img"><img :src="product.image"></td>
                        </tr>
                    </tbody>
                </table>
              </div>
              <!-- /ko -->
            </div>
        </div>
        <div v-show="productSelected">
            <div class="formBlock sel-prods" >
                <div class="blockTitle">{{messages["qsim.cart.title"]}}</div>
                <div>
                    <table class="total">
                    <tbody>
                        <tr>
                        <th>{{messages["qsim.cart.product"]}}</th>
                        <th>{{messages["qsim.cart.cost"]}}</th>
                        <th></th>
                        </tr>
                        <tr :key="product" :id="product.productId">
                        <td>{{product.displayName}}</td>
                        <td>{{product.totalPrice}}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
              </div>
              <input :value='messages["qsim.button2"]' class="button orderSubmit" type="submit" @click="sendToCart">
        </div>
  </div>
</template>

<script>


export default {
  name: 'Order',
  props: {
    messages: Object,
    atgProducts: Array
  },
  data: function () {
    return {
      product: {},
      productSelected: false
    }
  },
  mounted: function () {
    formInputInit();
    document.getElementsByClassName("productCheckbox")[0].click();
    document.getElementsByClassName("productCheckbox")[0].classList.add("selected")
  },
  methods: {
    selectSimProduct(event) {

        document.getElementsByClassName("productCheckbox").forEach(element => { 
          element.classList.remove("selected");
        })
        var productID;
        if (event.target.className == ".productCheckbox") {
            productID = event.target.id;
        } else {
            productID = event.target.closest(".productCheckbox").id;
        }

        var self = this;
        this.atgProducts.forEach(function (product) {
            if (product.productId == productID) self.product = product;
        });
        this.productSelected = true;
    },
    sendToCart(){
      var redirectUrl = `${document.getElementsByTagName("body")[0].dataset.windsite}deep-linking?journeyType=tangibleOnly&tangibleId=${this.product.productId}`
      window.location.href = redirectUrl;
    }
  }
}
</script>

<style>

</style>
